import React from "react";

const LearningNoteStepState = (props) => {

  const renderStep = () => {
    if(props.list.prgsByStgList){
      return(
        props.list.prgsByStgList.map((item, index) => (
          <section key={index}>
            <div className="num">{item.rowNum}</div>
            <div className= {`grade_cont ${item.color}`}>
              <div className="grade"><span>{item?.cdNm}</span></div>
            </div>
          </section>
        ))
      );
    }else{
      return <div></div>;
    }
  };

  return (
    <div className="step_state cls">
      {renderStep()}
    </div>
  );

};

export default LearningNoteStepState;



